// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { NoticeApi } from '../types/notices.types';
import { noticesHttpApi } from './notices.api';
import { noticesMockApi } from './notices.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const noticesApi: NoticeApi = useMock ? noticesMockApi : noticesHttpApi;
